const BXGXPromotionMessagesReducer = (state = [], action) => {
    switch (action.type) {
        case 'SET_BXGX_PROMOTION_MESSAGES':
            return action.payload;
        default:
            return state;
    }
};

export default BXGXPromotionMessagesReducer;
